import React from 'react';
import Image from '../Image';
import ButtonLink from '../interface/ButtonLink';
import { BannerWrapper, Title, ColumnWrapper, Column, ImageContainer, ButtonWrapper } from './SmallBanner.styles';

const SmallBanner = ({ mainTitle, text, linkTitle, image, ctaUrl }) => {
  return (
    <BannerWrapper>
      {image && (
        <ImageContainer>
          <Image image={image[0]} />
        </ImageContainer>
      )}
      {mainTitle && <Title>{mainTitle}</Title>}
      {text && (
        <ColumnWrapper>
          <Column>{text}</Column>
        </ColumnWrapper>
      )}
      {linkTitle && ctaUrl && (
        <ButtonWrapper>
          <ButtonLink href={ctaUrl.url} type={ctaUrl.type}>
            {linkTitle}
          </ButtonLink>
        </ButtonWrapper>
      )}
    </BannerWrapper>
  );
};

export default SmallBanner;
